/* Strum sections (sections/rb-strum-*.liquid, snippets/rb-strum-guitar.liquid).
   When the guitar scrolls into view the pick strums down once, each string rings and lights its row as the pick
   crosses it, then the pick plucks the landing string, which stays lit and fills the readout card.
   Tap a string or a row to pluck it. Tap the guitar body or the replay button to strum again.
   Reduced motion: no movement at all, the landing string is simply shown lit.
   Options on the section root: data-land (string index the strum lands on), data-dir="up" (strum from the bottom
   string to the top one, a real downstroke when the guitar is drawn in tab order). Elements with
   data-rbs-pane="<index>" get .is-on when that string is picked. Each ring fires an rbs:ring event (index). */
(function () {
  if (window.RBStrum) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = !!(Element.prototype.animate);
  var PICK_X = 510;
  var STRUM_FROM = 82;
  var STRUM_TO = 240;
  var STRUM_MS = 520;

  function vibFrames(sign, peak, size) {
    var amps = [0, 1, -0.86, 0.74, -0.62, 0.52, -0.42, 0.34, -0.26, 0.19, -0.13, 0.07, 0];
    var frames = [];
    for (var k = 0; k < amps.length; k++) {
      frames.push({
        transform: 'scaleY(' + (amps[k] * sign * size) + ')',
        opacity: k === amps.length - 1 ? 0 : peak,
        offset: k === amps.length - 1 ? 1 : (k / (amps.length - 2)) * 0.82,
        easing: 'ease-in-out'
      });
    }
    return frames;
  }
  var VIB = vibFrames(1, 1, 1);
  var GHOST = vibFrames(-1, 0.3, 1);
  var VIB_SOFT = vibFrames(1, 0.85, 0.7);
  var GHOST_SOFT = vibFrames(-1, 0.22, 0.7);

  function pickAt(y, rot) {
    return 'translate(' + PICK_X + 'px, ' + y + 'px) rotate(' + (rot == null ? -24 : rot) + 'deg)';
  }

  function Strum(root) {
    this.root = root;
    this.svg = root.querySelector('.rbs-gtr__svg');
    this.pick = root.querySelector('.rbs-pick');
    this.strings = [].slice.call(root.querySelectorAll('.rbs-str'));
    this.rows = [].slice.call(root.querySelectorAll('[data-rbs-row]'));
    this.rowAt = {};
    this.rows.forEach(function (r) { this.rowAt[r.getAttribute('data-rbs-row')] = r; }, this);
    this.live = this.strings.filter(function (s) { return !s.classList.contains('is-mute'); });
    this.land = parseInt(root.getAttribute('data-land'), 10) || 0;
    this.up = root.getAttribute('data-dir') === 'up';
    if (this.svg) {
      PICK_X = parseFloat(this.svg.getAttribute('data-pick-x')) || PICK_X;
      STRUM_FROM = parseFloat(this.svg.getAttribute('data-from')) || STRUM_FROM;
      STRUM_TO = parseFloat(this.svg.getAttribute('data-to')) || STRUM_TO;
    }
    this.active = -1;
    this.timers = [];
    this.pickY = STRUM_FROM;
    this.bind();
  }

  Strum.prototype.later = function (fn, ms) {
    this.timers.push(setTimeout(fn, ms));
  };

  Strum.prototype.stop = function () {
    this.timers.forEach(clearTimeout);
    this.timers = [];
  };

  Strum.prototype.y = function (i) {
    return parseFloat(this.strings[i].getAttribute('data-y'));
  };

  Strum.prototype.movePick = function (from, to, ms, easing, rotFrom, rotTo) {
    this.pickY = to;
    if (!this.pick) return;
    if (!canAnimate) { this.pick.setAttribute('transform', 'translate(' + PICK_X + ' ' + to + ') rotate(-24)'); return; }
    this.pick.animate([{ transform: pickAt(from, rotFrom) }, { transform: pickAt(to, rotTo) }], { duration: ms, easing: easing || 'ease-in-out', fill: 'forwards' });
  };

  // A strummed string flashes the accent for a moment and keeps vibrating in ink. A plucked string stays lit.
  Strum.prototype.ring = function (i, ms, holdLit) {
    var s = this.strings[i];
    if (!s) return;
    s.classList.add('is-lit');
    if (canAnimate && !reduce) {
      var bow = s.querySelector('.rbs-str__bow');
      var ghost = s.querySelector('.rbs-str__ghost');
      if (bow) bow.animate(holdLit ? VIB : VIB_SOFT, { duration: ms, easing: 'linear' });
      if (ghost) ghost.animate(holdLit ? GHOST : GHOST_SOFT, { duration: ms, easing: 'linear' });
    }
    if (!holdLit) this.later(function () { s.classList.remove('is-lit'); }, 240);
    var row = this.rowAt[i];
    if (row) {
      row.classList.add('is-lit');
      this.later(function () { row.classList.remove('is-lit'); }, 520);
    }
    this.root.dispatchEvent(new CustomEvent('rbs:ring', { detail: { index: i } }));
  };

  Strum.prototype.select = function (i) {
    if (i < 0 || i >= this.strings.length || this.strings[i].classList.contains('is-mute')) return;
    this.active = i;
    this.strings.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    this.rows.forEach(function (r) {
      var on = parseInt(r.getAttribute('data-rbs-row'), 10) === i;
      r.classList.toggle('is-active', on);
      r.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var row = this.rowAt[i];
    if (row) {
      [].forEach.call(this.root.querySelectorAll('[data-rbs-out]'), function (el) {
        var v = row.getAttribute('data-out-' + el.getAttribute('data-rbs-out'));
        if (v != null) el.textContent = v;
      });
    }
    [].forEach.call(this.root.querySelectorAll('[data-rbs-pane]'), function (el) {
      el.classList.toggle('is-on', parseInt(el.getAttribute('data-rbs-pane'), 10) === i);
    });
    [].forEach.call(this.root.querySelectorAll('[data-rbs-pop]'), function (el) {
      el.classList.remove('rbs-pop');
      void el.offsetWidth;
      el.classList.add('rbs-pop');
    });
    this.root.dispatchEvent(new CustomEvent('rbs:select', { detail: { index: i } }));
  };

  Strum.prototype.strum = function () {
    var self = this;
    this.stop();
    if (reduce) { this.select(this.land); return; }
    this.strings.forEach(function (s) { s.classList.remove('is-active'); });
    this.rows.forEach(function (r) { r.classList.remove('is-active'); });
    var a = this.up ? STRUM_TO : STRUM_FROM;
    var b = this.up ? STRUM_FROM : STRUM_TO;
    this.movePick(a + (this.up ? 10 : -10), a, 160, 'ease-out', -30, -24);
    var start = 180;
    this.later(function () { self.movePick(a, b, STRUM_MS, 'linear', -24, -12); }, start);
    this.live.forEach(function (s) {
      var i = parseInt(s.getAttribute('data-i'), 10);
      var t = start + STRUM_MS * Math.abs(self.y(i) - a) / Math.abs(b - a);
      self.later(function () { self.ring(i, 1500); }, t);
    });
    var back = start + STRUM_MS + 220;
    var ly = this.y(this.land);
    this.later(function () { self.movePick(b, ly - 22, 480, 'cubic-bezier(.3,.7,.2,1)', -12, -24); }, back);
    this.later(function () { self.pluck(self.land, true); }, back + 600);
  };

  Strum.prototype.pluck = function (i, fromStrum) {
    var self = this;
    if (i < 0 || !this.strings[i] || this.strings[i].classList.contains('is-mute')) return;
    if (!fromStrum) this.stop();
    if (reduce) { this.select(i); return; }
    var y = this.y(i);
    var from = this.pickY;
    var lead = 0;
    if (Math.abs(from - (y - 22)) > 2) {
      this.movePick(from, y - 22, 260, 'cubic-bezier(.3,.7,.2,1)', -24, -24);
      lead = 270;
    }
    this.later(function () { self.movePick(y - 22, y + 14, 150, 'cubic-bezier(.5,0,.8,.6)', -24, -14); }, lead);
    this.later(function () { self.ring(i, 1900, true); self.select(i); }, lead + 95);
    this.later(function () { self.movePick(y + 14, y - 20, 420, 'cubic-bezier(.2,.7,.2,1)', -14, -24); }, lead + 170);
    this.later(function () {
      self.strings.forEach(function (s, k) { if (k !== self.active) s.classList.remove('is-lit'); });
      if (self.strings[i]) self.strings[i].classList.remove('is-lit');
    }, lead + 2000);
  };

  Strum.prototype.bind = function () {
    var self = this;
    if (this.svg) {
      this.svg.addEventListener('click', function (e) {
        var hit = e.target.closest ? e.target.closest('.rbs-str') : null;
        if (hit && !hit.classList.contains('is-mute') && e.target.classList.contains('rbs-str__hit')) {
          self.pluck(parseInt(hit.getAttribute('data-i'), 10));
        } else {
          self.strum();
        }
      });
    }
    this.rows.forEach(function (r) {
      r.addEventListener('click', function () { self.pluck(parseInt(r.getAttribute('data-rbs-row'), 10)); });
    });
    [].forEach.call(this.root.querySelectorAll('[data-rbs-replay]'), function (b) {
      b.addEventListener('click', function () { self.strum(); });
    });
    var target = this.root.querySelector('.rbs-gtr') || this.root;
    if (reduce) { this.select(this.land); return; }
    if (!('IntersectionObserver' in window)) { this.strum(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          io.disconnect();
          setTimeout(function () { self.strum(); }, 250);
        }
      });
    }, { threshold: 0.6 });
    io.observe(target);
  };

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-rbs]'), function (root) {
      if (root.__rbs) return;
      root.__rbs = new Strum(root);
    });
  }

  window.RBStrum = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
